import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Boton from '../../commons/Boton';
import Tabla from '../../commons/Tabla';
import Texto from '../../commons/Texto';
import Bloque from '../../commons/Bloque';
import Modal from '../../commons/Modal';
import Icon from '../../commons/Icon';
import { formatoMonetario } from '../../commons/Utilitarios';

import {
  getInventariosAction,
  getLotesInventariosAction,
  getSeleccionarInventarioAction,
  actualizarFiltros,
  getConvertirInventarioAction,
} from '../../redux/actions/inventario.action';

import { getSeleccionarOperacionAction } from '../../redux/actions/operacion.action';

import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import ProductConvert from '../../assets/icons/convert-product.svg';
import UpDown from '../../assets/icons/upDown.svg';

import InventarioStock from './InventarioStock';

const InventarioList = ({
  inventarios,
  lots,
  processing,
  perfil,
  total,
  getInventariosAction,
  getLotesInventariosAction,
  getSeleccionarInventarioAction,
  actualizarFiltros,
  getConvertirInventarioAction,
  getSeleccionarOperacionAction,
  searchable,
  onClose,
  onSend,
}) => {
  const [selected, setSelected] = useState(null);
  const [openDetail, setOpenDetail] = useState(false);

  useEffect(() => {
    return () => {
      setSelected(null);
      setOpenDetail(false);
    };
  }, []);

  useEffect(() => {
    if (selected) {
      setSelected({ ...selected, lts: lots });
      setOpenDetail(true);
    }
  }, [lots]);

  const columns = [
    {
      key: 'su',
      align: 'center',
      content: (item) => (
        <div style={{ display: 'flex' }}>
          {perfil === 'NOBASICO' && (
            <>
              {searchable ? (
                <div title="Enviar">
                  <CheckIcon
                    onClick={() => {
                      setSelected(item);
                      getLotesInventariosAction({ su: item.su, mt: item.mt });
                    }}
                    style={{ color: 'green', cursor: 'pointer' }}
                  />
                </div>
              ) : (
                <>
                  <div title="Editar">
                    <EditIcon
                      onClick={() => getSeleccionarInventarioAction(item)}
                      style={{ color: 'green', cursor: 'pointer' }}
                    />
                  </div>
                  <Icon
                    svg={ProductConvert}
                    color="#3f51b5"
                    title="Convertir"
                    onClick={() => getConvertirInventarioAction(item)}
                  />
                  <Icon
                    svg={UpDown}
                    color="blue"
                    size={25}
                    title="Registrar movimiento"
                    onClick={() => getSeleccionarOperacionAction(item)}
                  />
                </>
              )}
            </>
          )}
        </div>
      ),
    },
    {
      key: 'ns',
      label: 'Sucursal',
    },
    {
      key: 'cm',
      align: 'center',
      label: 'Código',
    },
    {
      key: 'nm',
      label: 'Producto / Insumo',
    },
    {
      key: 'um',
      label: 'Unidad de medida',
    },
    {
      key: 'sd',
      align: 'center',
      label: 'Stock disponible',
    },
    {
      key: 'pv',
      align: 'right',
      label: 'Precio venta',
      content: (item) =>
        `${item.tm === 0 ? 'PEN' : 'USD'} ${formatoMonetario(item.pv)}`,
    },
    {
      key: 'dt',
      label: 'Categoría',
    },
  ];

  return (
    <>
      {searchable ? (
        <Modal
          title="B&uacute;squeda de inventarios"
          closePressEscape={false}
          closeWithoutConfirmation
          onClose={() => onClose()}
        >
          <Tabla
            columns={columns}
            data={inventarios}
            processing={processing}
            total={total}
            onPagination={({ page, rows }) =>
              getInventariosAction({ page, pageSize: rows })
            }
            onSearching={() => getInventariosAction({})}
            onChangeSearching={(search) => actualizarFiltros({ search })}
            onDoubleClick={(item) => {
              setSelected(item);
              getLotesInventariosAction({ su: item.su, mt: item.mt });
            }}
            style={{ flexBasis: '100%' }}
          />
        </Modal>
      ) : (
        <Bloque titulo="Resultado de b&uacute;squeda">
          <Tabla
            columns={columns}
            data={inventarios}
            processing={processing}
            total={total}
            onPagination={({ page, rows }) =>
              getInventariosAction({ page, pageSize: rows })
            }
            onSearching={() => getInventariosAction({})}
            onChangeSearching={(search) => actualizarFiltros({ search })}
          />
        </Bloque>
      )}
      {openDetail && (
        <InventarioStock
          title={selected.nm}
          inventory={selected}
          onClose={() => {
            setOpenDetail(false);
            setSelected(null);
          }}
          onSend={(item) => {
            onSend(item);
            setOpenDetail(false);
            setSelected(null);
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    inventarios: state.inventario.inventarios,
    lots: state.inventario.lots,
    processing: state.inventario.processing,
    total: state.inventario.total,
    perfil: state.app.currentUser.tr,
  };
};

export default connect(mapStateToProps, {
  getInventariosAction,
  getLotesInventariosAction,
  getSeleccionarInventarioAction,
  actualizarFiltros,
  getConvertirInventarioAction,
  getSeleccionarOperacionAction,
})(InventarioList);
